<!--
 * @Descripttion: 
 * @version: 
 * @Author: renqiang_hu
 * @Date: 2020-12-21 09:49:52
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-23 15:01:37
 * @FilePath: \heshan_web\src\page\index\top\top-notice.vue
-->
<template>
  
   <div slot="reference" @click="toalarm">
      <el-badge :value="dotval" >
        <i class="el-icon-bell"></i>
      </el-badge>
    </div>
</template>

<script>
import { getAlarmData} from '@/api/deviceOverview/alarm';
export default {
  name: "top-notice",
  data () {
    return {
     isdot:true,
     //  data: list,
      data: [],
      dotval:0,
      timer:null
    }
  },
  created () {
    this.getAlarmData()
    this.timer = null
    this.setalarm()
  },
  beforeDestroy(){
    clearInterval(this.timer)
  },
  methods: {
    setalarm(){
      this.timer = setInterval(()=>{
        this.getAlarmData()
      },30000)
    },
    getAlarmData(){
      getAlarmData({size:500,handleFlag:'0'}).then(res=>{
          if(res.data.code==200){
            this.dotval = res.data.data.total
          }
      })
    },
    toalarm(){
      this.$router.push('/failWarning/alarmData')
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
